import React from 'react';
import PropTypes from 'prop-types';
import { Layout, useMediaQuery } from '@americanexpress/dls-react';

const CollageImage = ({ src, alt }) => (
  <div
    role="img"
    aria-label={alt}
    className="width-full height-full"
    style={{
      backgroundImage: `url(${src})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }}
  />
);

const CollageVideo = ({ src, poster, alt }) => (
  <video
    className="width-full height-full"
    autoPlay
    muted
    playsInline
    preload="auto"
    aria-label={alt}
    poster={poster || undefined}
    style={{
      objectFit: 'cover',
      display: 'block',
    }}
  >
    <source src={src} type="video/mp4" />
  </video>
);

const HotelImageCollage = ({ hotelName, photos, heroVideoUrl }) => {
  const isDesktop = useMediaQuery('(min-width: 800px)');
  const collageHeight = isDesktop ? 560 : 400;
  const tileHeight = collageHeight / 2;
  const [heroPhoto, secondPhoto, thirdPhoto] = photos || [];

  if (!heroPhoto && !heroVideoUrl) {
    return null;
  }

  return (
    <Layout innerContainerClassName="border-0 no-scroll margin-t" variant="card">
      <div
        className="row radius-container"
        style={{ height: `${collageHeight}px`, overflow: 'hidden' }}
      >
        <div
          className="col-xs-12 col-md-8 pad-0 border-r-md-up"
          style={{ height: `${collageHeight}px` }}
        >
          {heroVideoUrl ? (
            <CollageVideo
              src={heroVideoUrl}
              poster={heroPhoto}
              alt={`${hotelName} — hotel video`}
            />
          ) : (
            <CollageImage src={heroPhoto} alt={`${hotelName} — main photo`} />
          )}
        </div>
        <div className="col-xs-12 col-md-4" style={{ height: `${collageHeight}px` }}>
          <div className="row height-full">
            {[secondPhoto, thirdPhoto].map((photo, i) => (
              <div
                key={photo || i}
                className={`col-xs-12 pad-0 border-l border-r-md-up ${i === 0 ? 'border-b' : 'border-t'}`}
                style={{ height: `${tileHeight}px` }}
              >
                {photo ? (
                  <CollageImage src={photo} alt={`${hotelName} — photo ${i + 2}`} />
                ) : null}
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
};

HotelImageCollage.propTypes = {
  hotelName: PropTypes.string,
  photos: PropTypes.arrayOf(PropTypes.string),
  heroVideoUrl: PropTypes.string,
};

CollageImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};

CollageVideo.propTypes = {
  src: PropTypes.string.isRequired,
  poster: PropTypes.string,
  alt: PropTypes.string.isRequired,
};

export default HotelImageCollage;
